export const TOGGLE_USERTEL_ERR = 'logintel/TOGGLE_USERTEL_ERR';
export const TOGGLE_PHONEPYZM_ERR = 'logintel/TOGGLE_PHONEPYZM_ERR';
export const HANDLE_USERTEL_CHANGE = 'logintel/HANDLE_USERTEL_CHANGE';
export const HANDLE_PHONEPYZM_CHANGE = 'logintel/HANDLE_PHONEPYZM_CHANGE';
export const TOGGLE_SENDING = 'logintel/TOGGLE_SENDING';
export const SET_YZM_SIGN = 'logintel/SET_YZM_SIGN';
export const SET_YZM_BTN_TEXT = 'logintel/SET_YZM_BTN_TEXT';
export const SET_COUNT_DOWN_NUM = 'logintel/SET_COUNT_DOWN_NUM';
export const RESET_FORM = 'logintel/RESET_FORM';
export const MANU_BTN_CLICK = 'logintel/MANU_BTN_CLICK';














